import React, { useState, useEffect, useCallback } from "react";
import { Field, Form, Formik } from "formik";
import { useHistory } from 'react-router-dom';
import {
  getPostInitialValues,
  VALIDATION_SCHEMA,
} from "web/components/utils/requestOrdersUtils";
import { adminFetchLocationListApi } from "redux/actions/adminPtPlusOrderRequests";
import { fetchSpecialLocationListApi } from 'redux/actions/adminPtPlus/index';
import * as moment from "moment";
import { FORMAT } from "web/components/utils/dateOfBirthValidation";
import RecurringOrderModal from "web/components/RecurringOrderModal";
import TextArea from "web/components/form-elements/TextArea";
import { useDispatch, useSelector } from 'react-redux';
import AlertModal from "web/components/AlertModal";
import Breadcrumb from "web/components/Breadcrumb";
import UploadSpecificationPTPLUS from "web/components/UploadSpecificationPTPLUS";
import LoadDetails from "web/pages/private/Admin/PTPlus/OrderRequest/loadDetails"
import NumberInput from "web/components/form-elements/NumberInput";
import RadioButton from "web/components/form-elements/RadioButton";
import CheckboxInput from "web/components/form-elements/CheckboxInput";
import DropDown from "web/components/DropDown";
import Select from "web/components/form-elements/Select";
import Button from "web/components/Button";
import Spinner from 'web/components/Spinner';
import TooltipMaterial from "@material-ui/core/Tooltip";
import UploadDummy from "web/assets/images/UploadDummy.png";
import CloseIcon from "web/assets/images/CloseIcon.png";
import styled from 'styled-components';
import { BodyContainer, Footer, FormWrapper, UploadSpec, InputFieldsWrapper } from "./OrderStyled"

import {
  uploadSpectFilePTMS,
  createOrder,
  updateRequestedOrder,
  orderRefNumber,
  palletDetails
} from "redux/actions/adminPtPlus";

const OrderRequest = () => {
  const token = localStorage.getItem("token")
  let history = useHistory()
  const dispatch = useDispatch();
  const adminRoles = useSelector(state => state.admin.adminRoles)
  const loaderVisible = useSelector(state => state.appReducer.loaderVisible);
  const [companyName, setSelectCompanyName] = useState();
  const [locationName, setLocationName] = useState();

  const [recurringModal, setRecurringModal] = useState(false)

  const [filesArr, setFilesArr] = useState();
  const [addresResponse, setAddresResponse] = useState();
  const [gradeState, setGradeState] = useState();
  const customerId = localStorage.getItem("locationID")
  const equipmentList = ["Flatbed", "Enclosed Trailer", "Straight Truck"]
  const [loadDetailsState, setLoadDetailsState] = useState();

  let hardOrSoftWoodArray = ['New - Hardwood', 'New - Softwood']
  const [hardOrSoftWoodValue, setHardOrSoftWoodValue] = useState('')

  const [modal, setModal] = useState(false);
  const [modalContent, setModalContent] = useState("");
  const [modalTitle, setModalTitle] = useState("");
  const [modalLink, setModalLink] = useState("/");
  const toggleModal = () => setModal(!modal);

  const urlObject = useSelector(
    (state) => state.urlParameters.requestedId
  );

  const [palletDetailResponse, setPalletDetailResponse] = useState();
  useEffect(() => {
    let userRole = localStorage.getItem('accountType')
    let appUserRolesList = ['Both', 'Buyer', 'Seller']
    if (userRole !== 'Admin') {
      if (appUserRolesList.includes(userRole)) history.push('/dashboard')
      else history.push('/sign-in')
      window.location.reload();
    }
    if (!token) {
      history.push('./sign-in')
      window.location.reload(false);
    } else {
      fetchMyAPI()
    }
  }, []);
  const fetchMyAPI = useCallback(async () => {
    if (token === null) {
      setModalContent("Please Sign In again.");
      setModalLink("/");
      toggleModal();
    } else {
      let response = await dispatch(palletDetails(token));

      if (response?.success) {
        setPalletDetailResponse(response?.data)
        locationListAPI(response?.data)
      } else {
        if (response?.statusCode === 401) {
          history.push('./sign-in')
          window.location.reload(false);
        } else {
          setModalContent(response?.data?.error?.message || response.message || 'Something went wrong, please try again!');
          setModalLink("");
          toggleModal();
        }
      }
    }
  }, []);
  const businessNameList = [
    {
      label: "",
      value: "",
    },
  ];

  const [alertType, setAlertType] = useState();
  const [editResponse, setEditResponse] = useState();
  const [uploadSpectState, setUploadSpectState] = useState();

  const formSubmit = async (props) => {
    if (urlObject?.id) {
      let fromTimeValue = parseInt(props.values.apptEdit?.replace(":", ""));
      let toTimeValue = parseInt(props.values.apptToEdit?.replace(":", ""));
      if (toTimeValue < fromTimeValue) {
        setModalContent("Appointment window time is invalid.")
        setModalLink("");
        toggleModal();
        return false;
      }
    } else if (props.values.addMoreArrList.length !== 0) {
      for (let i = 0; i < props.values.addMoreArrList.length; i++) {
        let fromTimeValueTemp = props.values.addMoreArrList[i].appt
        let toTimeValueTemp = props.values.addMoreArrList[i].apptTo || props.values.apptTo
        let fromTimeValue = parseInt(fromTimeValueTemp?.replace(":", ""));
        let toTimeValue = parseInt(toTimeValueTemp?.replace(":", ""));
        if (toTimeValue < fromTimeValue) {
          setModalContent("Appointment window time is invalid.")
          setModalLink("");
          toggleModal();
          return false;
        }
      }
    }

    if ((props?.values?.grade === "Custom" || props?.values?.size === "Custom" || props?.values?.material === "OTHER" || props?.values?.material === "PLASTIC") && (!props?.values?.length || !props?.values?.width || !props?.values?.height)) {
      setModalContent("size is a required field. Please populate and resubmit.");
      setModalLink("");
      toggleModal();
    } else if (!companyName) {
      setModalContent("Company name is a required field. Please populate and resubmit.");
      setModalLink("");
      toggleModal();
    } else if (!locationName) {
      setModalContent("location name is a required field. Please populate and resubmit.");
      setModalLink("");
      toggleModal();
    }
    else if (props?.values?.size !== "Custom" && gradeState?.length && !props?.values?.grade) {
      setModalContent("Grade is a required field. Please populate and resubmit.");
      setModalLink("");
      toggleModal();
    } else if (loadDetailsState) {
      setModalContent("Date should not be before minimal date or invalid date.");
      setModalLink("");
      toggleModal();
    }
    else {
      if (filesArr && filesArr.length !== 0) {
        let formData = new FormData();
        for (let i = 0; i < filesArr.length; i++) {
          formData.append("file", filesArr[i]);
        }
        let response = await dispatch(uploadSpectFilePTMS(formData, token))
        if (response?.success) {
          let s3FilesArr = []
          for (let i = 0; i < response?.data?.s3UploadedFiles.length; i++) {
            let obj = {
              orignalFileName: response?.data?.s3UploadedFiles[i].fileName,
              fileName: response?.data?.s3UploadedFiles[i].s3FfileName
            }
            s3FilesArr.push(obj)
            if (response?.data?.s3UploadedFiles.length - 1 === i) {
              setUploadSpectState(s3FilesArr)
              submitApi(props, s3FilesArr)
            }
          }
        } else {
          if (response.statusCode === 401) {
            history.push('./sign-in')
            window.location.reload(false);
          } else {
            setModalContent(response?.data?.error?.message);
            setModalLink("");
            toggleModal();
          }
        }
      } else {
        if (props?.values?.size === "Custom" && !uploadImageStage) {
          setModalContent("Upload specification is a required field. Please populate and resubmit.");
          setModalLink("");
          toggleModal();
        } else {
          if (uploadSpectState && uploadSpectState.length !== 0) {
            let arr = []
            for (let i = 0; i < uploadSpectState.length; i++) {
              if (uploadSpectState[i].label) {
                let obj = {
                  orignalFileName: uploadSpectState[i].label,
                  fileName: uploadSpectState[i].value
                }
                arr.push(obj)
              }

              if (uploadSpectState.length - 1 === i) {
                setUploadSpectState(arr)
                submitApi(props, arr)
              }
            }
          } else {
            submitApi(props)
          }
        }
      }
    }
  }

  const submitApi = async (props, spectFiles) => {
    let conditionArr = [];
    if (props?.values?.condition0) {
      conditionArr.push("RECYCLED");
    }
    if (props?.values?.condition1) {
      conditionArr.push("NEW");
    }
    if (props?.values?.condition2) {

      conditionArr.push("COMBO");
    }
    if (props?.values?.condition3) {
      conditionArr = []
      conditionArr.push("CORES");
    }

    if (conditionArr.length === 0 && props?.values?.material !== "OTHER") {
      setModalContent("Condition is a required field. Please populate and resubmit.");
      setModalLink("");
      toggleModal();
      return false;
    }
    else if (props?.values?.material === "WOOD" && !props?.values?.palletType) {
      setModalContent("Pallet Type is a required field. Please populate and resubmit.");
      setModalLink("");
      toggleModal();
      return false;
    } else if (getMoisture.length !== 0 && !props?.values?.moisture) {
      setModalContent("Moisture is a required field. Please populate and resubmit.");
      setModalLink("");
      toggleModal();
      return false;
    }
    else if (props?.values?.material === "WOOD" && props?.values?.palletType && !props?.values?.size) {
      setModalContent("Size is a required field. Please populate and resubmit.");
      setModalLink("");
      toggleModal();
      return false;
    } else if (getGradeList.length !== 0 && !props?.values?.grade) {
      setModalContent("Grade is a required field. Please populate and resubmit.");
      setModalLink("");
      toggleModal();
      return false;
    }
    if (props?.values?.cloneOrder && !props?.values?.orderId) {
      setModalContent("Order Id is a required field. Please populate and resubmit.");
      setModalLink("");
      toggleModal();
      return false;
    }

    let equipmentRequirements = []
    if (props.values.equipment0) {
      equipmentRequirements.push("FLAT_BED")
    } if (props.values.equipment1) {
      equipmentRequirements.push("ENCLOSED_TRAILER")
    } if (props.values.equipment2) {
      equipmentRequirements.push("STRAIGHT_TRUCK")
    }

    if (equipmentRequirements.length === 0) {
      setModalContent("Equipment is a required field. Please populate and resubmit.");
      setModalLink("");
      toggleModal();
      return false;
    }

    let loadDetailsArr = []
    if (props.values.addMoreArrList.length !== 0 && props.values.addMoreArrList[0].lots && props.values.addMoreArrList[0].QuantityLot) {
      for (let i = 0; i < props.values.addMoreArrList.length; i++) {
        if (props.values.addMoreArrList[i].lots && props.values.addMoreArrList[i].QuantityLot) {
          if (props.values.addMoreArrList[i].requestDeliveryDate) {
            let obj = {
              requestDeliveryDate: moment(props.values.addMoreArrList[i].requestDeliveryDate).format('YYYY-MM-DD HH:mm'),
              deliveryFromtime: urlObject?.id ? props.values.apptEdit : props.values.addMoreArrList[i].appt,
              deliveryTotime: urlObject?.id ? props.values.apptToEdit : props.values.addMoreArrList[i].apptTo || props.values.apptTo,
              lotType: props?.values?.lotsOption,

              poNumber: props.values.addMoreArrList[i].poNumber,

              postType: "NEED",
              quantityDetails: {
                lots: parseInt(props.values.addMoreArrList[i].lots),
                quantity: props.values.addMoreArrList[i].QuantityLot,
                originalQuantity: props.values.quantityMaxValue
              },
            }
            loadDetailsArr.push(obj)
          } else {
            setModalContent("Delivery date is a required field. Please populate and resubmit.");
            setModalLink("");
            toggleModal();
            return false
          }

        } else {
          if (!props.values.addMoreArrList[i].lots) {
            setModalContent("Number of loads is a required field. Please populate and resubmit.");
            setModalLink("");
            toggleModal();
            return false
          }
          if (!props.values.addMoreArrList[i].QuantityLot) {
            setModalContent("Quantity per loads is a required field. Please populate and resubmit.");
            setModalLink("");
            toggleModal();
            return false
          }
        }
      }

      // creating object for recurring order
      let recurranceObject = null
      if (props.values?.recurringCheckBoxFlag) {
        recurranceObject = {
          recType: props.values?.recTypeTemp,
          startDate: props.values?.recStartDate,
          endDate: props.values?.recEndDate,
          pattern: {
            weekly: {},
            monthly: {}
          }
        }
        if (props.values?.recTypeTemp === 'WEEKLY') {
          recurranceObject.pattern.monthly = null
          recurranceObject.pattern.weekly.recuringEvery = props.values?.weeklyRecEvery
          recurranceObject.pattern.weekly.weekdays = props.values?.weeklyRecDays
        } else if (props.values?.recTypeTemp === 'MONTHLY') {
          recurranceObject.pattern.weekly = null
          recurranceObject.pattern.monthly.monthlyType = props.values.monthlyRecType
          recurranceObject.pattern.monthly.dayType = {}
          recurranceObject.pattern.monthly.custom = {}
          if (props.values.monthlyRecType === 'DAY') {
            recurranceObject.pattern.monthly.custom = null
            recurranceObject.pattern.monthly.dayType.recuringDay = props.values?.monthlyDayTypeRecDay
            recurranceObject.pattern.monthly.dayType.recuringEvery = props.values?.monthlyDayTypeRecEvery
          } else if (props.values.monthlyRecType === 'CUSTOM') {
            recurranceObject.pattern.monthly.dayType = null
            recurranceObject.pattern.monthly.custom.weekOfMonth = props.values?.monthlyCustomeTypeStartDateOfWeek
            recurranceObject.pattern.monthly.custom.reccuringWeek = props.values?.monthlyCustomeTypeStarWeektDayOfWeek
            recurranceObject.pattern.monthly.custom.recuringEvery = props.values?.monthlyCustomeTypeRecEvery
          }
        }
      }

      let data;
      if (urlObject?.id) {
        data = {
          orderRefNumber: urlObject?.id,
          //Pallet Details
          palletDetails: {
            material: props?.values?.material,
            condition: props?.values?.material === "OTHER" ? [] : conditionArr,
            // newHardware: props?.values?.newHardware || '',
            palletType: props?.values?.material === "OTHER" || props?.values?.material === "PLASTIC" ? "CUSTOM" : props?.values?.palletType ? props?.values?.palletType.toUpperCase() : "CUSTOM",
            moisture: props?.values?.material === "OTHER" || props?.values?.material === "PLASTIC" ? "" : props?.values?.moisture,
            size: props?.values?.size,
            grade: props?.values?.grade,
            length: parseFloat(props?.values?.length) || "",
            width: parseFloat(props?.values?.width) || "",
            height: parseFloat(props?.values?.height) || "",
            heatTreared: props.values.isHeatTreared,
          },
          specificationFiles: (spectFiles && spectFiles.length > 0) ? spectFiles : ((uploadSpectState && uploadSpectState?.length > 0) ? uploadSpectState : ((uploadImageStage && uploadImageStage.length > 0) ? uploadImageStage : [])),
          // Location Name & Address
          equipmentRequirements: equipmentRequirements,
          loadDetails: loadDetailsArr,

          location: {
            locationId: locationName || "",
            shippingAddress: getLocationAddressState?.filter(locations => locations.locationId === locationName)[0]?.address,
            // shippingAddress: {
            //   name: urlObject?.items?.addressDTO?.name,
            //   contactNumber: urlObject?.items?.addressDTO?.contactNumber,
            //   locationName: urlObject?.items?.addressDTO?.locationName ? urlObject?.items?.addressDTO?.locationName : urlObject?.items?.addressDTO?.name,
            //   street: urlObject?.items?.addressDTO?.street,
            //   city: urlObject?.items?.addressDTO?.city,
            //   state: urlObject?.items?.addressDTO?.state,
            //   zipCode: urlObject?.items?.addressDTO?.zipCode
            // }
          },
          modifiedBy: localStorage.getItem('adminName') || "ADMIN",
          remark: props?.values?.remark,
          customer: {
            customerId: companyName
          },
          postRecurring: props.values?.recurringCheckBoxFlag,
          recurrance: recurranceObject
        }
      } else {
        data = {
          palletDetails: {
            material: props?.values?.material,
            condition: props?.values?.material === "OTHER" ? [] : conditionArr,
            palletType: props?.values?.material === "OTHER" || props?.values?.material === "PLASTIC" ? "CUSTOM" : props?.values?.palletType ? props?.values?.palletType.toUpperCase() : "CUSTOM",
            moisture: props?.values?.material === "OTHER" || props?.values?.material === "PLASTIC" ? "" : props?.values?.moisture,
            size: props?.values?.size,
            grade: props?.values?.grade,
            length: parseFloat(props?.values?.length) || "",
            width: parseFloat(props?.values?.width) || "",
            height: parseFloat(props?.values?.height) || "",
            heatTreared: props.values.isHeatTreared,
          },
          specificationFiles: (spectFiles && spectFiles.length > 0) ? spectFiles : ((uploadSpectState && uploadSpectState?.length > 0) ? uploadSpectState : ((uploadImageStage && uploadImageStage.length > 0) ? uploadImageStage : [])),

          // Location Name & Address
          orderRefNumber: "",
          equipmentRequirements: equipmentRequirements,
          loadDetails: loadDetailsArr,
          location: {
            locationId: locationName || "",
            shippingAddress: {
              name: locationAddress?.name,
              contactNumber: locationAddress?.contactNumber || "(213) 456-7811",
              locationName: locationAddress?.locationName ? locationAddress?.locationName : locationAddress?.name,
              street: locationAddress?.street,
              city: locationAddress?.city,
              state: locationAddress?.state,
              zipCode: locationAddress?.zipCode
            }
          },
          isCreatedByAdmin: true,
          customer: {
            customerId: companyName
          },
          remark: props?.values?.remark,
          postRecurring: props.values?.recurringCheckBoxFlag,
          recurrance: recurranceObject
        }
      }

      if (conditionArr?.includes('NEW') && props.values?.hardOrSoftWood !== '') {
        data.palletDetails.newConditionType = props.values?.hardOrSoftWood === 'New - Hardwood' ? 'HARDWOOD' : 'SOFTWOOD'
      }

      if (!token) {
        history.push('./sign-in')
        window.location.reload(false);
      } else {
        let response
        if (urlObject?.id) {
          response = await dispatch(updateRequestedOrder(data, token));
        } else {
          response = await dispatch(createOrder(data, token));
        }

        if (response?.success) {
          setModalTitle("")
          if (urlObject?.id) {
            setModalContent("Your order request has been modified.");
          } else {
            setModalContent("Order request created successfully.");
          }

          setModalLink("");
          toggleModal();
          setAlertType("success")
        } else {
          if (response.statusCode === 401) {
            history.push('./sign-in')
            window.location.reload(false);
          } else {
            setAlertType()
            setModalContent(response?.data?.error?.message);
            setModalLink("");
            toggleModal();
          }
        }
      }
    } else {
      setAlertType()
      setModalContent("Number of loads is a required field. Please populate and resubmit.");
      setModalLink("");
      toggleModal();
      return false;
    }
  }
  const formFilledBasedOnResponse = (referenceResponse, editFlag, palletResponse) => {
    let palletType = referenceResponse?.palletDetails?.palletType?.toLowerCase()
    if (palletType === "euro" || referenceResponse?.data?.palletDetails?.palletType === "EUROPALLET") {
      palletType = "euroPallet"
    }
    setMaterialResponse(referenceResponse?.palletDetails?.material)

    let fileArr = []
    for (let i = 0; i < referenceResponse?.specificationFiles.length; i++) {
      const fileObject =
      {
        label: referenceResponse?.specificationFiles[i]?.orignalFileName,
        value: referenceResponse?.specificationFiles[i]?.fileName,
      }

      fileArr.push(fileObject)
      if (i === referenceResponse?.specificationFiles.length - 1) {
        setUploadImage(fileArr)
        setUploadSpectState(fileArr)
      }
    }

    if (referenceResponse?.palletDetails?.material !== "PLASTIC" && referenceResponse?.palletDetails?.material !== "OTHER") {
      palletTypeData('', palletType, editFlag, referenceResponse, palletResponse)
    }
  }
  const formFilledBasedOnResponseId = (referenceResponse, props, setFieldValue, editFlag) => {
    // For Conditions
    for (let i = 0; i < referenceResponse?.data?.palletDetails?.condition.length; i++) {
      if (referenceResponse?.data?.palletDetails?.condition[i] === "RECYCLED") {
        setFieldValue("condition0", true)
      } if (referenceResponse?.data?.palletDetails?.condition[i] === "NEW") {
        setFieldValue("condition1", true)
      } if (referenceResponse?.data?.palletDetails?.condition[i] === "COMBO") {
        setFieldValue("condition2", true)
      } if (referenceResponse?.data?.palletDetails?.condition[i] === "CORES") {
        setFieldValue("condition3", true)
        setFieldValue("condition0", false)
        setFieldValue("condition1", false)
        setFieldValue("condition2", false)
      }
    }

    for (let j = 0; j < referenceResponse?.data?.equipmentRequirements.length; j++) {
      if (referenceResponse?.data?.equipmentRequirements[j] === "FLAT_BED") {
        setFieldValue("equipment0", true)
      } if (referenceResponse?.data?.equipmentRequirements[j] === "ENCLOSED_TRAILER") {
        setFieldValue("equipment1", true)
      } if (referenceResponse?.data?.equipmentRequirements[j] === "STRAIGHT_TRUCK") {
        setFieldValue("equipment2", true)
      }
    }


    let palletType = referenceResponse?.data?.palletDetails?.palletType?.toLowerCase()
    if (palletType === "euro" || referenceResponse?.data?.palletDetails?.palletType === "EUROPALLET") {
      palletType = "euroPallet"
    }
    setMaterialResponse(referenceResponse?.data?.palletDetails?.material)
    setFieldValue("palletType", palletType)


    setFieldValue("material", referenceResponse?.data?.palletDetails?.material)
    setFieldValue("moisture", referenceResponse?.data?.palletDetails?.moisture)
    setFieldValue("size", referenceResponse?.data?.palletDetails?.size)
    setFieldValue("grade", referenceResponse?.data?.palletDetails?.grade)

    let fileArr = []
    for (let i = 0; i < referenceResponse?.data?.specificationFiles.length; i++) {
      const fileObject =
      {
        label: referenceResponse?.data?.specificationFiles[i]?.orignalFileName,
        value: referenceResponse?.data?.specificationFiles[i]?.fileName,
      }

      fileArr.push(fileObject)
      if (i === referenceResponse?.data?.specificationFiles.length - 1) {
        setUploadImage(fileArr)
        setUploadSpectState(fileArr)
      }
    }


    setFieldValue("length", referenceResponse?.data?.palletDetails?.length)
    setFieldValue("width", referenceResponse?.data?.palletDetails?.width)
    setFieldValue("height", referenceResponse?.data?.palletDetails?.height)

    if (referenceResponse?.data?.palletDetails?.condition[0] !== "CORES") {
      setIsHeatTreared(true)
    }

    setFieldValue("isHeatTreared", referenceResponse?.data?.palletDetails?.heatTreared)

    setFieldValue("addMoreArrList.[0].lots", referenceResponse?.data?.loadDetails?.quantityDetails?.lots)
    setFieldValue("addMoreArrList.[0].QuantityLot", referenceResponse?.data?.loadDetails?.quantityDetails?.quantity)
    setFieldValue("addMoreArrList.[0].poNumber", referenceResponse?.data?.loadDetails?.poNumber)

    setFieldValue("lots", referenceResponse?.data?.loadDetails?.quantityDetails?.lots)
    setFieldValue("QuantityLot", referenceResponse?.data?.loadDetails?.quantityDetails?.quantity)

    setFieldValue("businessName", referenceResponse?.data?.location?.locationId)
    setFieldValue("poNumber", referenceResponse?.data?.loadDetails?.poNumber)
    let arr = []
    arr.push(referenceResponse?.data?.loadDetails)
    setLoadDetailsState(arr)
    palletTypeData(props, palletType, editFlag, referenceResponse)
  }

  const woodConditions = ["Recycled", "New", "Combo"]
  const plasticConditions = ["Recycled", "New"]
  const [materialResponse, setMaterialResponse] = useState("WOOD");
  const [getMoisture, setMoisture] = useState([]);
  const [getSizeList, setSizeList] = useState([]);
  const [getGradeList, setGradeList] = useState([]);
  const [uploadImageStage, setUploadImage] = useState();
  const [isHeatTrearedFlag, setIsHeatTreared] = useState(false);

  const orderRefNumberAPI = async (refNumber, companyResponse, palletResponse) => {
    if (token === null) {
      setModalContent("Please Sign In again.");
      setModalLink("/");
      toggleModal();
    } else {
      let response = await dispatch(orderRefNumber(refNumber, token));

      if (response?.success) {
        if (response?.data) {
          setSelectCompanyName(response?.data?.customer?.customerId)
          formFilledBasedOnResponse(response?.data, true, palletResponse)
          let obj = {
            label: response?.data?.data?.shippingAddress?.name,
            value: response?.data?.data?.location?.locationId,
            response: response?.data?.data?.shippingAddress
          }
          setAddresResponse(obj)

          if (response?.data?.loadDetails?.quantityDetails?.originalQuantity) {
            setMaxQuantityState(response?.data?.loadDetails?.quantityDetails?.originalQuantity)
          }

          setEditResponse(response?.data)

          getLocationAddress(response?.data?.customer?.customerId)

          for (let j = 0; j < companyResponse.length; j++) {
            if (response?.data?.customer?.customerId === companyResponse[j].value) {

              let arr = [];

              for (let i = 0; i < companyResponse[j]?.arrList?.length; i++) {
                if (companyResponse[j]?.arrList[i].locationId === response?.data?.location?.locationId) {
                  let obj = {
                    label: companyResponse[j]?.arrList[i].locationName + ' - ' + companyResponse[j]?.arrList[i].city + ', ' + companyResponse[j]?.arrList[i].state + ', ' + companyResponse[j]?.arrList[i].zip,
                    value: companyResponse[j]?.arrList[i].locationId,

                  };
                  arr.push(obj);
                  setLocationListResponse(arr)
                  setLocationName(companyResponse[j]?.arrList[i].locationId)
                }
              }
            }
          }

        } else {
          setAddresResponse(response)
        }
      } else {
        if (response?.statusCode === 401) {
        } else {
          setModalContent(response?.data?.error?.message);
          setModalLink("");
          toggleModal();
        }
      }
    }
  };
  const selectComapnyName = [
    {
      label: "",
      value: "",
    },
  ];
  const [locationListResponse, setLocationListResponse] = useState();
  const [companyNameResponse, setCompanyNameResponse] = useState(selectComapnyName);
  const locationListAPI = useCallback(async (palletResponse) => {
    if (token === null) {
      history.push('./sign-in')
      window.location.reload(false);
    } else {
      let response = await dispatch(adminFetchLocationListApi(customerId, token));
      if (response?.success) {
        let locationTemp = response?.data?.customerAndLocations;
        let arr = [];
        for (let i = 0; i < locationTemp.length; i++) {
          let obj = {
            label: locationTemp[i].customer + ' - ' + locationTemp[i].city + ', ' + locationTemp[i].state + ', ' + locationTemp[i].zip,
            value: locationTemp[i].customerId,
            arrList: locationTemp[i].locationIdAndNames
          };
          arr.push(obj);

          if (i === locationTemp.length - 1) {
            setCompanyNameResponse(arr)

            if (urlObject?.id) {
              orderRefNumberAPI(urlObject?.id, arr, palletResponse)
            }
          }
        }
      } else {
        if (response.statusCode === 401) {
          history.push('./sign-in')
          window.location.reload(false);
        } else {
          setModalContent(response?.data?.error?.message);
          setModalLink("");
          toggleModal();
        }
      }
    }
  }, []);

  const [locationAddress, setLocationAddress] = useState();
  const [getLocationAddressState, setLocationAddressState] = useState();
  const getLocationAddress = async (customerId) => {
    if (token === null) {
      setModalContent("Please Sign In again.");
      setModalLink("/");
      toggleModal();
    } else {
      let response = await dispatch(fetchSpecialLocationListApi(customerId, token));
      let arr = []
      if (response?.success) {
        if (response?.data?.locations[0]?.mainLocation) {
          let obj = {
            locationId: response?.data?.locations[0]?.mainLocation?.locationId,
            address: response?.data?.locations[0]?.mainLocation?.address
          }
          arr.push(obj)
        }
        if (response?.data?.locations[0]?.subLocations) {
          for (let i = 0; i < response?.data?.locations[0]?.subLocations.length; i++) {
            let obj = {
              locationId: response?.data?.locations[0]?.subLocations[i]?.locationId,
              address: response?.data?.locations[0]?.subLocations[i]?.address
            }
            arr.push(obj)
          }
        }
        setLocationAddressState(arr)
      } else {
        if (response.statusCode === 401) {
          history.push('./sign-in')
          window.location.reload(false);
        } else {
          setModalContent(response?.data?.error?.message);
          setModalLink("");
          toggleModal();
        }
      }
    }
  }

  const materialArr = [
    {
      id: "0",
      label: "Wood",
      value: "WOOD",
    },
    {
      id: "1",
      label: "Plastic",
      value: "PLASTIC",
    },
    {
      id: "2",
      label: "Other",
      value: "OTHER",
    },
  ];
  let palletList = [
    {
      label: "Block",
      value: "block",
      id: 0,
    },
    {
      label: "Stringer",
      value: "stringer",
      id: 1,
    },
    {
      label: "Euro Pallet",
      value: "euroPallet",
      id: 2,
    },
    {
      label: "Crate",
      value: "crate",
      id: 3,
    },
    {
      label: "Tray",
      value: "tray",
      id: 4,
    },
    {
      label: "Other",
      value: "other",
      id: 5,
    }
  ]
  let comboPalletList = [
    {
      label: "Stringer",
      value: "stringer",
      id: 1,
    },
    {
      label: "Crate",
      value: "crate",
      id: 2,
    },
    {
      label: "Custom",
      value: "custom",
      id: 3,
    }
  ]
  let corePalletList = [
    {
      label: "Block",
      value: "block",
      id: 0,
    },
    {
      label: "Stringer",
      value: "stringer",
      id: 1,
    }
  ]
  const materialDiv = (setFieldValue) => {
    return (
      <>
        <div className="col-5 text-left mb-40">
          <p className="sec-label">Material</p>
          <div className="row">
            {materialArr?.map((value, index) => (
              <div key={index} className="col-4">
                <Field
                  component={RadioButton}
                  name="material"
                  id={value.value}
                  defaultValue={materialResponse}
                  onSelect={(e) => {
                    setSizeList([])
                    setGradeList([])
                    setMoisture([])
                    setFieldValue("palletType", "")
                    setFieldValue("moisture", "")
                    setFieldValue("size", "")
                    setFieldValue("grade", "")
                    setIsHeatTreared(false)
                    setFieldValue("condition0", false)
                    setFieldValue("condition1", false)
                    setFieldValue("condition2", false)
                    setFieldValue("condition3", false)
                    setFieldValue("hardOrSoftWood", '');
                    setFieldValue("length", "")
                    setFieldValue("width", "")
                    setFieldValue("height", "")
                    setFieldValue("isHeatTreared", false)

                    setUploadSpectState()
                    if (e.target.value === "PLASTIC") {
                      setFieldValue("addMoreArrList.[0].QuantityLot", 786)
                      setFieldValue('quantityMaxValue', 786)
                      setMaxQuantityState(786)
                    } else {
                      setFieldValue("addMoreArrList.[0].QuantityLot", 540)
                      setFieldValue('quantityMaxValue', 540)
                      setMaxQuantityState(540)
                    }

                    setUploadImage()
                    setMaterialResponse(e.target.value)
                  }}
                  label={value.label}
                />
              </div>
            ))}
          </div>
        </div></>
    );
  };
  const conditions = (setFieldValue, arrList) => {
    return (
      <div className="text-left mb-40">
        <p className="sec-label">Condition</p>
        <div className="row">
          {arrList?.map((value, index) => (
            <div style={{ width: '130px', marginLeft: '15px', "margin-top": "-18px" }} key={index}>
              <CheckboxInput
                name={"condition" + index}
                label={arrList[index]}
                onChange={(val, label) => {
                  setSizeList([])
                  setGradeList([])
                  setMoisture([])
                  setUploadImage()
                  setFieldValue("palletType", "")
                  setFieldValue("moisture", "")
                  setFieldValue("size", "")
                  setFieldValue("grade", "")
                  setFieldValue("length", "")
                  setFieldValue("width", "")
                  setFieldValue("height", "")
                  setFieldValue("isHeatTreared", false)
                  setIsHeatTreared(false)

                  setFieldValue("condition0", false)
                  setFieldValue("condition1", false)
                  setFieldValue("condition2", false)
                  setFieldValue("condition3", false)
                  setFieldValue("hardOrSoftWood", '');

                  if (label === "Recycled" && val)
                    setFieldValue("condition0", true)

                  if (label === "New" && val)
                    setFieldValue("condition1", true)

                  if (label === "Combo" && val)
                    setFieldValue("condition2", true)

                  if (label === "Cores" && val)
                    setFieldValue("condition3", true)
                }}
              />
            </div>
          ))}
        </div>
      </div>
    );
  };

  const hardOrSoftWoodDiv = (setFieldValue) => {
    return (
      <div className="row hardSoftWoodRadioStyle condition-styles mb-3">
        {hardOrSoftWoodArray &&
          hardOrSoftWoodArray.map((value, index) => (
            <HardSoftWoodWrapper>
              <Field
                component={RadioButton}
                name="hardOrSoftWood"
                id={value}
                defaultValue={hardOrSoftWoodArray[0]}
                onSelect={(e) => {
                  let tempValue = hardOrSoftWoodValue === e.target?.value ? '' : e.target?.value
                  setFieldValue('hardOrSoftWood', tempValue)
                  setHardOrSoftWoodValue(tempValue)
                }}
                label={value}
              />
            </HardSoftWoodWrapper>
          ))}
      </div>
    );
  };

  const sizeArrayList = (props, palletType, editFlag, referenceResponse, palletResponse) => {
    if (palletType === "europallet") {
      palletType = "euroPallet"
    }
    let selectedMaterial = props?.values?.material.toLowerCase()
    let conditionTypes = []
    if (editFlag) {
      for (let i = 0; i < referenceResponse?.palletDetails?.condition.length; i++) {
        if (referenceResponse?.palletDetails?.condition[i] === "RECYCLED") {
          conditionTypes.push("recycled")
        } if (referenceResponse?.palletDetails?.condition[i] === "NEW") {
          conditionTypes.push("newCondition")
        } if (referenceResponse?.palletDetails?.condition[i] === "COMBO") {
          conditionTypes.push("combo")
        } if (referenceResponse?.palletDetails?.condition[i] === "CORES") {
          conditionTypes.push("cores")
        }
      }
      selectedMaterial = referenceResponse?.palletDetails?.material.toLowerCase()
    } else {
      if (props?.values?.condition0) {
        conditionTypes.push("recycled")
      }
      if (props?.values?.condition1) {
        conditionTypes.push("newCondition")
      }
      if (props?.values?.condition2) {
        conditionTypes.push("combo")
      }
      if (props?.values?.condition3) {
        conditionTypes.push("cores")
      }
    }

    let palletResponseSet = palletDetailResponse
    if (!palletDetailResponse && palletResponse) {
      palletResponseSet = palletResponse
    }

    let sizeArr = []
    for (let j = 0; j < conditionTypes.length; j++) {
      let response = palletResponseSet[selectedMaterial].condition[conditionTypes[j]][palletType]
      if (response?.palletSpecificDetails.length !== 0) {
        for (let i = 0; i < response?.palletSpecificDetails.length; i++) {
          if (response?.palletSpecificDetails[i]?.size !== '') {
            const sizeObject =
            {
              label: response?.palletSpecificDetails[i]?.size,
              value: response?.palletSpecificDetails[i]?.size,
              quantity: response?.palletSpecificDetails[i]?.quantity,
            }

            sizeArr.push(sizeObject)
          }

          if (response?.palletSpecificDetails.length - 1 === i) {
            if (conditionTypes.length - 1 === j) {
              if (sizeArr.length === 0) {
                gradeArrayList(props, palletType, editFlag, referenceResponse)
              }
              else {
                if (urlObject?.id && referenceResponse?.palletDetails?.grade) {
                  gradeArrayList(props, palletType, editFlag, referenceResponse, palletResponse)
                }
              }
            }

            const sizeNames = sizeArr.map(val => val.value)
            const sizeListFilter = sizeArr.filter(({ value }, index) => !sizeNames.includes(value, index + 1))

            setSizeList(sizeListFilter)
          }
        }
      }
    }
  }
  const gradeArrayList = (props, palletType, editFlag, referenceResponse, palletResponse) => {
    let selectedMaterial = props?.values?.material.toLowerCase()
    let conditionTypes = []
    if (editFlag) {
      for (let i = 0; i < referenceResponse?.palletDetails?.condition.length; i++) {
        if (referenceResponse?.palletDetails?.condition[i] === "RECYCLED") {
          conditionTypes.push("recycled")
        } if (referenceResponse?.palletDetails?.condition[i] === "NEW") {
          conditionTypes.push("newCondition")
        } if (referenceResponse?.palletDetails?.condition[i] === "COMBO") {
          conditionTypes.push("combo")
        } if (referenceResponse?.palletDetails?.condition[i] === "CORES") {
          conditionTypes.push("cores")
        }
      }
      selectedMaterial = referenceResponse?.palletDetails?.material.toLowerCase()
    } else {
      if (props?.values?.condition0) {
        conditionTypes.push("recycled")
      }
      if (props?.values?.condition1) {
        conditionTypes.push("newCondition")
      }
      if (props?.values?.condition2) {
        conditionTypes.push("combo")
      }
      if (props?.values?.condition3) {
        conditionTypes.push("cores")
      }
    }

    let palletResponseSet = palletDetailResponse
    if (!palletDetailResponse && palletResponse) {
      palletResponseSet = palletResponse
    }
    let gradeArr = []
    for (let j = 0; j < conditionTypes.length; j++) {
      let response = palletResponseSet[selectedMaterial].condition[conditionTypes[j]][palletType]
      if (response?.palletSpecificDetails.length !== 0) {
        for (let i = 0; i < response?.palletSpecificDetails.length; i++) {
          if (response?.palletSpecificDetails[i]?.grade !== '') {
            const gradeObject =
            {
              label: response?.palletSpecificDetails[i]?.grade,
              value: response?.palletSpecificDetails[i]?.grade,
            }

            gradeArr.push(gradeObject)
          }

          if (response?.palletSpecificDetails.length - 1 === i) {
            const gradeNames = gradeArr.map(val => val.value)
            const gradeListFilter = gradeArr.filter(({ value }, index) => !gradeNames.includes(value, index + 1))
            setGradeList(gradeListFilter)
          }
        }
      } else {
        setMoisture([])
        setSizeList([])
      }
    }
  }
  const palletType = (props, setFieldValue) => {
    return (
      <div className="app-input-text mb-26">
        <Select
          name="palletType"
          data={props?.values?.condition2 ? comboPalletList : props?.values?.condition3 ? corePalletList : palletList}
          placeholder={"Pallet Type"}
          disabled={!props?.values?.condition0 && !props?.values?.condition1 && !props?.values?.condition2 && !props?.values?.condition3 ? true : false}
          searchable={true}
          onChangeHandler={(val) => {
            let palletType = val.value
            //clearFileds()
            setUploadImage()
            setGradeList([])
            setFieldValue("palletType", "")
            setFieldValue("moisture", "")
            setFieldValue("size", "")
            setFieldValue("grade", "")
            setIsHeatTreared(false)
            if (palletType === "europallet") {
              palletType = "euroPallet"
            }
            palletTypeData(props, palletType)
          }}
        />
      </div>
    );
  };

  const palletTypeData = (props, palletType, editFlag, referenceResponse, palletResponse) => {

    let moistureArr = []
    let conditionTypes = []
    let selectedMaterial = props?.values?.material?.toLowerCase()
    if (editFlag) {
      for (let i = 0; i < referenceResponse?.palletDetails?.condition.length; i++) {
        if (referenceResponse?.palletDetails?.condition[i] === "RECYCLED") {
          conditionTypes.push("recycled")
        } if (referenceResponse?.palletDetails?.condition[i] === "NEW") {
          conditionTypes.push("newCondition")
        } if (referenceResponse?.palletDetails?.condition[i] === "COMBO") {
          conditionTypes.push("combo")
        } if (referenceResponse?.palletDetails?.condition[i] === "CORES") {
          conditionTypes.push("cores")
        }
      }
      selectedMaterial = referenceResponse?.palletDetails?.material.toLowerCase()
    } else {
      if (props?.values?.condition0) {
        conditionTypes.push("recycled")
      }
      if (props?.values?.condition1) {
        conditionTypes.push("newCondition")
      }
      if (props?.values?.condition2) {
        conditionTypes.push("combo")
      }
      if (props?.values?.condition3) {
        conditionTypes.push("cores")
      }
    }

    if (palletType === "custom") {
      const sizeObject = [
        {
          label: "Custom",
          value: "Custom",
        }
      ]
      setSizeList(sizeObject)
    }
    if (palletType === "europallet") {
      palletType = "euroPallet"
    }
    let palletResponseSet = palletDetailResponse
    if (!palletDetailResponse && palletResponse) {
      palletResponseSet = palletResponse
    }
    for (let j = 0; j < conditionTypes.length; j++) {
      let response = palletResponseSet[selectedMaterial].condition[conditionTypes[j]][palletType]
      if (response?.palletSpecificDetails.length !== 0) {
        for (let i = 0; i < response?.palletSpecificDetails.length; i++) {
          if (response?.palletSpecificDetails[i]?.moisture !== '') {
            const moistureObject =
            {
              label: response?.palletSpecificDetails[i]?.moisture,
              value: response?.palletSpecificDetails[i]?.moisture,
            }
            moistureArr.push(moistureObject)
          }

          if (response?.palletSpecificDetails.length - 1 === i) {
            const moistureNames = moistureArr.map(val => val.value)
            const moistureArrListFilter = moistureArr.filter(({ value }, index) => !moistureNames.includes(value, index + 1))
            setMoisture(moistureArrListFilter)
            if (conditionTypes.length - 1 === j) {
              if (moistureArr.length === 0) {
                if (urlObject?.id) {
                  sizeArrayList(props, palletType, editFlag, referenceResponse, palletResponse)
                } else {
                  sizeArrayList(props, palletType)
                }

              } else {
                if (editResponse || editFlag) {
                  sizeArrayList(props, palletType, editFlag, referenceResponse, palletResponse)
                }
              }
            }
          }
        }
      } else {
        setMoisture([])
        setSizeList([])
      }
    }


  }

  const moisture = (props) => {
    return (
      <div className="app-input-text mb-26">
        <Select
          name="moisture"
          data={getMoisture}
          placeholder={"Moisture"}
          disabled={getMoisture.length === 0 ? true : false}
          searchable={true}
          onChangeHandler={() => {
            setIsHeatTreared(false)
            setUploadImage()
            let palletType = props?.values?.palletType
            sizeArrayList(props, palletType)
          }}
        />
      </div>
    );
  };

  const [quantityValueState, setQuantityValueState] = useState(540);
  const [maxQuantityState, setMaxQuantityState] = useState(540);

  const size = (props, setFieldValue) => {
    return (
      <div className="app-input-text mb-26">
        <Select
          name="size"
          data={getSizeList}
          placeholder={"Size"}
          disabled={getSizeList.length === 0 ? true : false}
          searchable={true}
          onChangeHandler={(val, data) => {
            setGradeList([])
            setUploadImage()
            setFieldValue("grade", "")
            setFieldValue("length", "")
            setFieldValue("width", "")
            setFieldValue("height", "")
            uploadSpecificationFiles(props, false)
            if (val?.quantity) {
              setMaxQuantityState(parseInt(val?.quantity))
              setQuantityValueState(val?.quantity)
              setFieldValue("addMoreArrList.[0].QuantityLot", val?.quantity);
              setFieldValue('quantityMaxValue', val?.quantity)

              let quantity = props?.values?.lots * val?.quantity;
              let radixPos = String(quantity).indexOf(".");
              if (radixPos !== -1) {
                quantity = parseInt(quantity) + parseInt(1);
              }
              if (quantity === 0) {
                quantity = ""
              }
              setFieldValue("TotalQuantity", quantity);
            }

            if (props.values.condition3) {
              setIsHeatTreared(false)
            } else {
              setIsHeatTreared(true)
            }
            let gradeArr = []
            let filesArr = []
            let conditionTypes = []
            if (props?.values?.condition0) {
              conditionTypes.push("recycled")
            }
            if (props?.values?.condition1) {
              conditionTypes.push("newCondition")
            }
            if (props?.values?.condition2) {
              conditionTypes.push("combo")
            }
            if (props?.values?.condition3) {
              conditionTypes.push("cores")
            }

            const selectedMaterial = props?.values?.material.toLowerCase()
            let palletType = props?.values?.palletType.toLowerCase()
            if (palletType === "europallet") {
              palletType = "euroPallet"
            }

            let response = palletDetailResponse[selectedMaterial].condition[conditionTypes[0]][palletType]
            for (let i = 0; i < response?.palletSpecificDetails.length; i++) {
              if (val.value === response?.palletSpecificDetails[i]?.size) {
                if (response?.palletSpecificDetails[i]?.grade !== '') {
                  const gradeObject =
                  {
                    label: response?.palletSpecificDetails[i]?.grade,
                    value: response?.palletSpecificDetails[i]?.grade,
                  }

                  gradeArr.push(gradeObject)
                }
                if (props?.values?.moisture === response?.palletSpecificDetails[i]?.moisture) {
                  if (response?.palletSpecificDetails[i]?.file !== '' && response?.palletSpecificDetails[i]?.file !== "Custom Spec Upload") {
                    const fileObject =
                    {
                      label: response?.palletSpecificDetails[i]?.file,
                      value: response?.palletSpecificDetails[i]?.file,
                    }

                    filesArr.push(fileObject)
                  }
                } else {
                  if (!props?.values?.moisture && response?.palletSpecificDetails[i]?.file !== '' && response?.palletSpecificDetails[i]?.file !== "Custom Spec Upload") {

                    const fileObject =
                    {
                      label: response?.palletSpecificDetails[i]?.file,
                      value: response?.palletSpecificDetails[i]?.file,
                    }
                    filesArr.push(fileObject)
                  } else {
                    if (response?.palletSpecificDetails[i]?.file !== '' && response?.palletSpecificDetails[i]?.file !== "Custom Spec Upload") {
                      const fileObject =
                      {
                        label: response?.palletSpecificDetails[i]?.file,
                        value: response?.palletSpecificDetails[i]?.file,
                      }
                      filesArr.push(fileObject)
                    }
                  }
                }
              }

              if (response?.palletSpecificDetails.length - 1 === i) {
                const gradeNames = gradeArr.map(val => val.value)
                const gradeListFilter = gradeArr.filter(({ value }, index) => !gradeNames.includes(value, index + 1))
                setGradeList(gradeListFilter)
                // gradeCallBack(gradeListFilter)

                if (gradeListFilter.length === 0) {

                  const filesNames = filesArr.map(val => val.value)
                  const fileListFilter = filesArr.filter(({ value }, index) => !filesNames.includes(value, index + 1))
                  setUploadImage(fileListFilter)
                  setUploadSpectState(fileListFilter)
                }
              }
            }
          }}
        />
      </div>
    );
  };

  let fileArr = [];
  const uploadSpecificationFiles = (props, flag) => {
    // let flag = false
    if (props?.values?.grade === "Custom" || props?.values?.size === "Custom") {
      flag = true
    }
    return (
      <div className="stepUpload request-order-upload-section" style={{ "margin-top": "15px" }}>
        <UploadSpecificationPTPLUS
          acceptFiles={"image/png,image/jpeg,image/gif,image/GIF,application/pdf,application/PDF,.doc,.docx,application/msword,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
          }
          name="uploadSpecification"
          btnName={"Upload Specification"}
          mandatory={"Star"}
          props={props}
          fileArr={fileArr}
          callBackFun={(imageArr) => {
            setFilesArr(imageArr);
          }}
        />
      </div>)
  }
  const grade = (props) => {
    return (
      <div className="app-input-text mb-26">
        <Select
          name="grade"
          data={getGradeList}
          placeholder={"Grade"}
          disabled={getGradeList.length === 0 || props?.values?.size === "Custom" ? true : false}
          searchable={true}
          onChangeHandler={(val) => {
            if (props.values.condition3) {
              setIsHeatTreared(false)
            } else {
              setIsHeatTreared(true)
            }
            uploadSpecificationFiles(props, false)

            let filesArr = []
            let conditionTypes = []
            if (props?.values?.condition0) {
              conditionTypes.push("recycled")
            }
            if (props?.values?.condition1) {
              conditionTypes.push("newCondition")
            }
            if (props?.values?.condition2) {
              conditionTypes.push("combo")
            }
            if (props?.values?.condition3) {
              conditionTypes.push("cores")
            }

            const selectedMaterial = props?.values?.material.toLowerCase()
            let palletType = props?.values?.palletType.toLowerCase()
            if (palletType === "europallet") {
              palletType = "euroPallet"
            }

            let response = palletDetailResponse[selectedMaterial].condition[conditionTypes[0]][palletType]
            for (let i = 0; i < response?.palletSpecificDetails.length; i++) {

              if (response?.palletSpecificDetails[i].size === props?.values?.size) {

                if (val.value === response?.palletSpecificDetails[i]?.grade) {
                  if (response?.palletSpecificDetails[i]?.file !== '' && response?.palletSpecificDetails[i]?.file !== "Custom Spec Upload") {
                    const fileObject =
                    {
                      label: response?.palletSpecificDetails[i]?.file,
                      value: response?.palletSpecificDetails[i]?.file,
                    }

                    filesArr.push(fileObject)
                  }
                }
              }

              if (response?.palletSpecificDetails.length - 1 === i) {
                const filesNames = filesArr.map(val => val.value)
                const fileListFilter = filesArr.filter(({ value }, index) => !filesNames.includes(value, index + 1))
                setUploadImage(fileListFilter)
                setUploadSpectState(fileListFilter)
              }

            }
          }}
        />
      </div>
    );
  };
  const customFields = () => {
    return (
      <div className="col-12 text-left  mb-40">
        <div className="row">
          <div className="col-md-4 col-sm-6">
            <div className="app-input-text">
              <NumberInput
                name="length"
                placeholder="Length*"
                maxLength={5}
                showErrorMessages={true}
              />
            </div>
          </div>
          <div className="col-md-4 col-sm-6">
            <div className="app-input-text">
              <NumberInput
                name="width"
                placeholder="Width*"
                maxLength={5}
                showErrorMessages={true}
              />
            </div>
          </div>
          <div className="col-md-4 col-sm-6">
            <div>
              <NumberInput
                name="height"
                placeholder="Height*"
                maxLength={5}
                onChangeHandler={() => { }}
              />
            </div>
          </div>
        </div>
      </div>
    );
  }

  const isHeatTreated = () => {
    return (
      <div className="col-12 text-left">
        <div className="row">
          <CheckboxInput
            name={"isHeatTreared"}
            label="Heat Treated"
            handleSelect={() => {
            }}
          />
        </div>
      </div>
    )
  }
  const defaultAttachedSpectFiles = () => {
    return (
      <div className="col-12 mb-2 max-3-row">
        {uploadImageStage.map((item, index) => (
          <div className="row mb-1" key={index}>

            <UploadSpec
              className="upload col-12"
            >
              <img
                src={UploadDummy}
                alt="upload Dummy"
              />
              <TooltipMaterial
                placement="top"
                arrow
                title={item?.label}
                enterTouchDelay={0}
              >
                <span onClick={() => {
                  generatePdfDocument(item?.label)
                }}>{item?.value}</span>
              </TooltipMaterial>

            </UploadSpec>
          </div>
        ))
        }
      </div >
    );

  }
  const generatePdfDocument = async (imagePath) => {

    const fileUrl = process.env.REACT_APP_PT_PLUS_API_URL + 'ptms/s3/get_file/' + imagePath
    window.open(fileUrl)
  };

  let breadcrumbMapArr

  if (!urlObject?.id) {
    breadcrumbMapArr = [
      {
        name: "PT+ Admin",
        link: "ptplus-user-managememt",
        eventType: "",
      },
    ];

  } else {
    breadcrumbMapArr = [
      {
        name: "PT+ Admin",
        link: "ptplus-user-managememt",
        eventType: "",
      },
      {
        name: "Order Requests",
        link: "ptplus-order-request-managememt",
        eventType: "",
      },
    ];
  }

  const removeRecurringSettingFunction = (formikSetFieldValueFunction) => {
    formikSetFieldValueFunction('recurringCheckBoxFlag', false)

    let requestDeliveryDate = moment(new Date().setDate(new Date().getDate() + 4)).format(FORMAT)
    let requestStartDateRecOrder = moment(new Date().setDate(new Date().getDate() + 2)).format(FORMAT)
    let requestEndDateRecOrder = moment(new Date().setDate(new Date().getDate() + 30)).format(FORMAT)
    formikSetFieldValueFunction('recTypeTemp', 'WEEKLY')
    formikSetFieldValueFunction('recStartDateTemp', requestStartDateRecOrder)
    formikSetFieldValueFunction('recEndDateTemp', requestEndDateRecOrder)
    formikSetFieldValueFunction('weeklyRecEveryTemp', 1)
    formikSetFieldValueFunction('weeklyRecDaysTemp', [])
    formikSetFieldValueFunction('monthlyRecTypeTemp', 'DAY')
    formikSetFieldValueFunction('monthlyDayTypeRecDayTemp', 1)
    formikSetFieldValueFunction('monthlyDayTypeRecEveryTemp', 1)
    formikSetFieldValueFunction('monthlyCustomeTypeStartDateOfWeekTemp', 'FIRST')
    formikSetFieldValueFunction('monthlyCustomeTypeStarWeektDayOfWeekTemp', 'MONDAY')
    formikSetFieldValueFunction('monthlyCustomeTypeRecEveryTemp', 1)

    formikSetFieldValueFunction(`addMoreArrList.[${0}].requestDeliveryDate`, requestDeliveryDate)
    formikSetFieldValueFunction(`addMoreArrList.[${0}].appt`, '00:00')
    formikSetFieldValueFunction(`addMoreArrList.[${0}].apptTo`, "23:00")
    formikSetFieldValueFunction(`apptEdit`, '00:00')
    formikSetFieldValueFunction(`apptToEdit`, "23:00")
  }

  const frameRecurringOrderSummary = (data) => {
    function capitalizeFirstLetter(str) {
      return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
    }
    function getWeekDaysInSequence(a, b) {
      const daysOrder = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];
      return daysOrder.indexOf(a) - daysOrder.indexOf(b);
    }
    let recTypeValue = capitalizeFirstLetter(data.recType || '')
    let recValuesText = ''
    if (data.recType === 'WEEKLY') {
      let weeklyDaysTemp = data.weeklyRecDays?.map(data => `${capitalizeFirstLetter(data).substring(0, 3)}`)
      weeklyDaysTemp = weeklyDaysTemp?.sort(getWeekDaysInSequence)
      recValuesText = `Every ${weeklyDaysTemp} for 
              ${data.weeklyRecEvery} week(s), Starting ${moment(data.recStartDate).format('MM/DD/YYYY')}, Ending ${moment(data.recEndDate).format('MM/DD/YYYY')}`
    } else if (data.recType === 'MONTHLY') {
      if (data.monthlyRecType === 'DAY') {
        recValuesText = `Day ${data.monthlyDayTypeRecDay} for every ${data.monthlyDayTypeRecEvery} month(s), 
              Starting ${moment(data.recStartDate).format('MM/DD/YYYY')}, Ending ${moment(data.recEndDate).format('MM/DD/YYYY')}`
      } else if (data.monthlyRecType === 'CUSTOM') {
        recValuesText = `${capitalizeFirstLetter(data.monthlyCustomeTypeStartDateOfWeek)} ${capitalizeFirstLetter(data.monthlyCustomeTypeStarWeektDayOfWeek).substring(0, 3)} 
              for every ${data.monthlyCustomeTypeRecEvery} month(s), Starting ${moment(data.recStartDate).format('MM/DD/YYYY')}, Ending ${moment(data.recEndDate).format('MM/DD/YYYY')}`
      }
    }
    return `${recTypeValue}: ${recValuesText}`
  }

  const formFields = (props, isValid, dirty, setFieldValue) => {
    return (
      <>
        <Form className="form-wrapper">
          <FormWrapper>
            <div>
              <InputFieldsWrapper>
                <div>

                  {!urlObject?.id &&
                    <div className="business-name-wrapper">
                      <div className="mb-20" style={{ width: "300px" }}>
                        <DropDown
                          name="companyName"
                          data={companyNameResponse}
                          searchDropDown={companyName}
                          searchable={true}
                          placeholder="Select Company Name*"
                          onChangeHandler={(data) => {
                            getLocationAddress(data?.value)
                            setSelectCompanyName(data.value)
                            let arr = [];
                            if (data?.arrList.length !== 0) {
                              for (let i = 0; i < data?.arrList.length; i++) {
                                let obj = {
                                  label: data?.arrList[i].locationName + ' - ' + data?.arrList[i].city + ', ' + data?.arrList[i].state + ', ' + data?.arrList[i].zip,
                                  value: data?.arrList[i].locationId,
                                };
                                arr.push(obj);
                                if (i === data?.arrList.length - 1) {
                                  setLocationListResponse(arr)
                                }
                              }
                            }

                          }}
                        />
                      </div>
                    </div>
                  }

                  <div className="business-name-wrapper">

                    <div className="app-input-text mb-20">
                      <p className="sec-label">Business Name<span className="star">*</span></p>

                      <DropDown
                        name="businessName"
                        data={locationListResponse ? locationListResponse : businessNameList}
                        searchDropDown={locationName}
                        searchable={true}
                        placeholder="Select"
                        disabled={urlObject?.id ? true : false}
                        onChangeHandler={(data) => {
                          setLocationName(data.value)
                          for (let i = 0; i < getLocationAddressState.length; i++) {
                            if (data.value === getLocationAddressState[i].locationId) {
                              setLocationAddress(getLocationAddressState[i].address)
                            }
                          }
                        }}
                      />
                    </div>

                    <div className="equipment-requirements-wrapper mb-20">
                      <div className="label-heading">
                        <p>Equipment Requirements (Select all that apply)<span className="star">*</span></p>
                      </div>
                      <div className="requirements-checkbox">
                        {equipmentList?.map((value, index) => (
                          <CheckboxInput
                            name={"equipment" + index}
                            // disabled={urlObject?.id ? true : false}
                            label={equipmentList[index]}
                            key={index}
                          />
                        ))}
                      </div>
                    </div>
                  </div>
                  <div>
                    <div className="label-heading"><p>Pallet Details<span className="star">*</span></p></div>
                    <div className="col-12">
                      <div className="row">
                        {materialDiv(setFieldValue)}
                        <div className="col-7">
                          {materialResponse === "WOOD" && conditions(setFieldValue, woodConditions)}
                          {materialResponse === "PLASTIC" && conditions(setFieldValue, plasticConditions)}
                          {props.values?.condition1 && materialResponse === "WOOD" && hardOrSoftWoodDiv(setFieldValue)}
                        </div>
                      </div>
                    </div>

                    <div className="col-12">
                      <div className="row">
                        <div className="col-md-3">
                          {materialResponse === "WOOD" && palletType(props, setFieldValue)}
                        </div>
                        <div className="col-md-3">
                          {materialResponse === "WOOD" && moisture(props, setFieldValue)}
                        </div>
                        <div className="col-md-3">
                          {materialResponse === "WOOD" && size(props, setFieldValue)}
                        </div>
                        <div className="col-md-3">
                          {materialResponse === "WOOD" && grade(props, setFieldValue)}
                        </div>
                      </div>
                    </div>

                    {(materialResponse !== "WOOD" || props?.values?.size === "Custom") && customFields(props)}

                    {isHeatTrearedFlag && isHeatTreated(props)}

                    {uploadSpecificationFiles(props, false)}
                    {uploadImageStage && defaultAttachedSpectFiles()}

                    {/* temporarily hidden dont delete */}
                    {/* <div>
                      <div style={{ display: 'flex', alignItems: 'center' }}>
                        <button className={(props.values.recurringCheckBoxFlag || recurringModal) ? 'rec-button-selected-style' : 'rec-button-unselected-style'}
                          onClick={() => setRecurringModal(true)}
                        >Setup Recurring Order</button>
                        {props.values.recurringCheckBoxFlag &&
                          <div style={{ marginLeft: '20px' }}>
                            <p style={{ fontSize: '13px', color: '#005586', fontWeight: 'bold', marginBottom: '0px' }}>Recurring Summary</p>
                            <p style={{ fontSize: '12px', height: '15px', marginTop: '0px' }}>{frameRecurringOrderSummary(props.values)}
                              <img className='rec-close-icon-style' src={CloseIcon} alt="close-icon" onClick={() => removeRecurringSettingFunction(props.setFieldValue)} /></p>
                          </div>
                        }
                      </div>
                      {recurringModal &&
                        <RecurringOrderModal
                          setFieldValueFunction={(fieldName, fieldValue) => {
                            props.setFieldValue(fieldName, fieldValue)
                          }}
                          formikValues={props.values}
                          toggleModal={(type) => {
                            setRecurringModal(false)
                            if (type === 'submit') props.setFieldValue('recurringCheckBoxFlag', true)
                          }}
                        />}
                    </div> */}

                    {/* {loadDetails(props, setFieldValue)} */}
                    <LoadDetails props={props} maxQuantityState={maxQuantityState} editResponse={editResponse} callBack={(value) => {
                      setQuantityValueState(value)
                    }} loadsCallBack={(data) => {
                      setLoadDetailsState(data)
                    }} />
                    <div className="label-heading mt-3"><p>Remarks</p></div>
                    <div className="col-12">
                      <div className="row">
                        <TextArea
                          name='remark'
                          maxLength='200'
                          showErrorMessages={true}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </InputFieldsWrapper>
            </div>

            <Footer>
              <Button
                type="app-green-button"
                handleClick={() => {
                  formSubmit(props)
                }}
                disabled={!(isValid && dirty)}
              >
                {urlObject?.id ? "Modify Request" : "Submit Request"}
              </Button>
            </Footer>
          </FormWrapper>
        </Form>
      </>
    );
  };

  return <BodyContainer>
    {(adminRoles && (adminRoles.includes('SUPER_ADMIN') || adminRoles.includes('PT_PLUS'))) ?
      <>{loaderVisible && <Spinner />}
        <Breadcrumb
          breadcrumbArr={breadcrumbMapArr}
          selected={!urlObject?.id ? 'New Order Request' : "Modify Order Request"}
          title=""
        />
        {!urlObject?.id ? <Formik
          initialValues={getPostInitialValues()}
          validationSchema={VALIDATION_SCHEMA()}
          onSubmit={() => { }}
        >
          {(props) => {
            const { isValid, dirty, setFieldValue } =
              props;

            return (
              <>
                {formFields(props, isValid, dirty, setFieldValue)}
              </>
            );
          }}
        </Formik> :
          <>{editResponse &&
            <Formik
              initialValues={getPostInitialValues(editResponse)}
              validationSchema={VALIDATION_SCHEMA()}
              onSubmit={() => { }}
            >
              {(props) => {
                const { isValid, dirty, setFieldValue } =
                  props;

                return (
                  <>
                    {formFields(props, isValid, dirty, setFieldValue)}
                  </>
                );
              }}
            </Formik>}</>}

        <AlertModal
          isOpen={modal}
          toggle={toggleModal}
          title={modalTitle}
          content={modalContent}
          link={modalLink}
          alertType={alertType}
          className="alert-msg-container"
          InnerClassName="alert-msg"
          callBackAlert={(val) => {
            if (val === "success") history.push('/ptplus-order-request-managememt')
            else toggleModal()
          }}
        /></> :
      <p>You are not authorized to view this page.</p>}
  </BodyContainer>;
};

export default OrderRequest;

const HardSoftWoodWrapper = styled.div`
  margin-left: 15px;
  margin-top: 10px;
  width: 275px;
  .radio-checkmark{
      width: 18px;
      height: 18px;
      border-radius: 0px;
    }
  .radio-checkmark:after {
    top: 2px;
    left: 2px;
    width: 12px;
    height: 12px;
    border-radius: 0px;
  }
  .radio-container {
    span {
      white-space : nowrap;
    }
  }
`